// This is used by both front-end and back-end. Ensure imports, if any, are compatible.

export type RedirectQueryParams = { [key: string]: boolean | string };

export type GetPageFn = (ehrSystem: string, brand: string) => string;

export type GetRedirectUrlOptions = {
    getBaseURL: GetPageFn; // getBaseURL, brand & ehrSystem are a tuple to compute the baseURL
    brand: string;
    ehrSystem: string;
    deviceType?: string;
    isCrossRegion?: boolean; // used in the MyChart mobile use-case.
    queryParams?: RedirectQueryParams; // any additional query params
};

/**
 * Builds a redirect URL for MyChart SAML based on the provided options.
 */
export const getRedirectUrl = (options: GetRedirectUrlOptions) => {
    const { brand, deviceType, ehrSystem, getBaseURL, isCrossRegion, queryParams } = options;

    const baseUrlString = getBaseURL(ehrSystem, brand);
    const baseUrl = new URL(baseUrlString);
    const urlSearchParams = new URLSearchParams(baseUrl.searchParams);

    // [SPI-2087] We found that MyChart mobile does not work with Cross Region.
    // by setting mobile=true, the SAML workflow can deep-link back to the MyChart App.
    if (deviceType === 'mobile' && !isCrossRegion) {
        urlSearchParams.set('mobile', 'true');
    }

    for (const key in queryParams) {
        if (queryParams[key] === null || queryParams[key] === undefined) {
            continue;
        }
        urlSearchParams.set(key, queryParams[key].toString());
    }

    if (urlSearchParams.toString()) {
        return `${baseUrl.origin}${baseUrl.pathname}?${urlSearchParams}`;
    } else {
        return baseUrl.toString();
    }
};
